import {ClientEvent, MatrixClient} from 'matrix-js-sdk';

export const restartClient = async (
  client: MatrixClient,
  ssoToken: string,
  maxRetries = 3,
  delay = 3000
): Promise<MatrixClient> => {
  try {
    // Do we need to stop and start or just set new token?

    //await stopMatrixClient(client);
    client.setAccessToken(ssoToken);
    //await client.startClient();
    return new Promise((resolve, reject) => {
      client.on(ClientEvent.Sync, (state) => {
        if (state === 'PREPARED' || state === 'SYNCING') {
          resolve(client);
        }
      });

      client.startClient({initialSyncLimit: 30}).catch(reject);
    });
  } catch (error) {
    console.error('Cannot restart matrix client: ', error);
    if (maxRetries > 0) {
      console.log(`Retrying... ${maxRetries} attempts left`);
      await new Promise((resolve) => setTimeout(resolve, delay));
      return restartClient(client, ssoToken, maxRetries - 1, delay);
    } else {
      throw error;
    }
  }
};
